import { api } from "./api";

const BASE_URL = "/users";

export const getUser = () => api.get(`${BASE_URL}/me`);
